import { render, staticRenderFns } from "./ServerInstanceList.vue?vue&type=template&id=266e90cc&scoped=true&"
import script from "./ServerInstanceList.vue?vue&type=script&lang=js&"
export * from "./ServerInstanceList.vue?vue&type=script&lang=js&"
import style0 from "./ServerInstanceList.vue?vue&type=style&index=0&id=266e90cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266e90cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266e90cc')) {
      api.createRecord('266e90cc', component.options)
    } else {
      api.reload('266e90cc', component.options)
    }
    module.hot.accept("./ServerInstanceList.vue?vue&type=template&id=266e90cc&scoped=true&", function () {
      api.rerender('266e90cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ServerInstanceList.vue"
export default component.exports